// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Vuex from 'vuex'
import store from '../src/vuex/store'

import * as echarts from 'echarts'
import axios from 'axios'
import lodash from 'lodash'
import GLOBAL from "./components/Globle.vue"
import App from './App.vue'
import "../static/theme/index.css"
import './assets/css/iconfont.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfontali/iconfont.css'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
Vue.use(Vuex);
Vue.config.productionTip = false;

//注入全局对象
Vue.prototype.GLOBAL = GLOBAL;

//注入第三方工具
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios=axios;
Vue.prototype.$lodash=lodash;
Vue.prototype._=lodash;
//注册全局指令-卡片拖动
Vue.directive('cardDrag', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el,binding,vnode,oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-card__header');
    const dragDom = el;
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      document.body.classList.add('no-select');
      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if(sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      }else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
});

//注册全局指令-dialog拖动
Vue.directive('dialogDrag', {
  // 当被绑定的元素插入到 DOM 中时
  inserted: function (el,binding,vnode,oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      document.body.classList.add('no-select');
      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if(sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      }else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
});

//注册全局指令-缩略图
Vue.directive('thumbnails',{
  inserted:function (element,binding,vnode,oldVnode) {
    element.querySelector('.thumbnails-button').onclick = (e) => {
      let classNameArr=element.className.split(' '),
          flag=false,
          index=-1
      for(let i=classNameArr.length;i>=0;i--){
        if(classNameArr[i]==='thumbnails'){
          index=i
          flag=true
          break
        }
      }
      if(flag && index>0){
        classNameArr.splice(index, 1);
      }else{
        classNameArr.push('thumbnails')
      }
      element.className=classNameArr.join(' ')
    }
  }
})

/**权限指令**/
Vue.directive('has', {
  inserted: function(el, binding) {
    try{
      if (!Vue.prototype.$_has(binding.value)) {
        el.parentNode.removeChild(el)
      }
    }catch(e){
      console.log(e.message)
    }
  }
})
//权限检查方法
Vue.prototype.$_has = function(value) {
  let isExist=false;
  let buttonPermsStr=localStorage.getItem("perms");
  if(!buttonPermsStr){
    return false;
  }
  let buttonPerms=JSON.parse(buttonPermsStr);
  for(let i=0;i<buttonPerms.length;i++){
    if(buttonPerms[i].indexOf(value)>-1){
      isExist=true;
      break;
    }
  }
  return isExist;
};
//  默认聚焦
Vue.directive('focus',{
  inserted:function(el){
      el.focus()
  }
})
let mainVue =  new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  /*created(){
    let that=this;
    bus.$on("login", url => {
      if (url === "/login") {
        that.$router.replace(url);
      }
    });
  }*/
})


export default mainVue;





// WEBPACK FOOTER //
// ./src/main.js